var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ve-histogram',{attrs:{"height":_vm.chartHeight,"data":_vm.chartData,"legend-visible":false,"colors":[_vm.color],"extend":_vm.extendSettings}})}
var staticRenderFns = []

export { render, staticRenderFns }